"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeModelCollectionReader = void 0;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var id_1 = require("../../../id");
var form_1 = require("../../form");
var collection_data_1 = require("../collection.data");
var image_field_1 = require("../fields/image.field");
var number_field_1 = require("../fields/number.field");
var true_size_field_1 = require("../fields/true.size.field");
var ReadUtil = tslib_1.__importStar(require("./collection.model.util"));
var IkeModelCollectionReader = /** @class */ (function () {
    function IkeModelCollectionReader(collection, schema, loader) {
        this.json = collection;
        this.schema = schema;
        this.loader = loader;
        this.collection = new collection_data_1.CollectionModel(schema, loader);
    }
    IkeModelCollectionReader.prototype.read = function () {
        var collectionJson = this.json;
        if (collectionJson.data != null && collectionJson.data.data != null) {
            this.collection.state.instanceId = collectionJson.data.data['_id'];
        }
        if (this.collection.instanceId == null) {
            this.collection.state.instanceId = collectionJson.objectId;
        }
        var state = this.collection.state;
        state.id = collectionJson.objectId;
        state.uuid = collectionJson.uuid;
        state.createdAt = new Date(collectionJson.createdAt);
        state.updatedAt = new Date(collectionJson.updatedAt);
        state.collectedBy = collectionJson.collectedBy;
        state.collectedWith = collectionJson.collectedWith;
        state.assignedTo = collectionJson.assignedTo;
        state.updatedBy = collectionJson.updatedBy;
        state.revision = collectionJson.revision;
        state.jobId = collectionJson.jobuuid;
        if (collectionJson.collectedAt != null) {
            state.collectedAt = core_api_1.ParseJSON.fromDate(collectionJson.collectedAt);
        }
        this.readMeasurements();
        this.readBrightnessCorrections();
        this.readCropParameters();
        this.readImageVisibilities();
        for (var _i = 0, _a = this.schema.fields; _i < _a.length; _i++) {
            var field = _a[_i];
            this.readField(this.collection, field, collectionJson.data.data);
        }
        return this.collection;
    };
    IkeModelCollectionReader.prototype.readField = function (target, schema, source) {
        var value = source[schema.id];
        // Check to make sure the value actually has something interesting in it.
        if (value == null) {
            return;
        }
        // Process sub forms
        if (form_1.FormModelFieldSubForm.isSubForm(schema)) {
            return this.loadSubForm(target, schema, value);
        }
        // Text based fields can just be set
        if (schema.type === core_api_1.IkeFieldType.TEXT) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.FILE_TOOL) {
            return this.loadFileTool(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.DATE) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.YES_NO) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.SELECT_LIST) {
            var f = target.getField(schema.id);
            f.Mutator.manual(value);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.NUMBER) {
            return this.loadNumber(target, schema, value);
        }
        // Load in CaptureFile information
        if (schema.type === core_api_1.IkeFieldType.TRUE_SIZE) {
            return this.loadCaptures(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.IMAGE) {
            return this.loadCaptures(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.VECTOR) {
            return this.loadVector(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.ANCHOR) {
            return this.loadAnchor(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.LOCATION) {
            return this.loadLocation(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.NESTED_LIST) {
            var nlField = target.getField(schema.id);
            nlField.Mutator.manual(value[0]);
            return;
        }
        if (schema.type === core_api_1.IkeFieldType.HEIGHT) {
            return this.loadHeight(target, schema, value);
        }
        if (schema.type === core_api_1.IkeFieldType.VERTICAL_SEPARATION) {
            return this.loadVerticalSeparation(target, schema, value);
        }
        throw new Error("Unable to find field Serializer for ".concat(schema.type));
    };
    IkeModelCollectionReader.prototype.loadSubForm = function (target, schema, source) {
        var instances = source;
        var field = target.getField(schema.id);
        if (instances.length === 0) {
            field.Mutator.clear();
        }
        for (var _i = 0, instances_1 = instances; _i < instances_1.length; _i++) {
            var data = instances_1[_i];
            var instanceId = data._id || id_1.IkeId.generate();
            field.Mutator.create(instanceId);
            var instance = field.getInstance(instanceId);
            for (var _a = 0, _b = schema.fields; _a < _b.length; _a++) {
                var f = _b[_a];
                this.readField(instance, f, data);
            }
        }
    };
    IkeModelCollectionReader.prototype.loadCaptures = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (source.length === 0) {
            if (true_size_field_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                field.Mutator.clear();
            }
            else if (image_field_1.CollectionModelFieldImage.isImageField(field)) {
                field.Mutator.clear();
            }
            return;
        }
        for (var _i = 0, source_1 = source; _i < source_1.length; _i++) {
            var ts = source_1[_i];
            if (true_size_field_1.CollectionModelFieldTrueSize.isTrueSizeField(field)) {
                field.Mutator.add(ts.capture.objectId);
            }
            else if (image_field_1.CollectionModelFieldImage.isImageField(field)) {
                field.Mutator.add(ts.capture.objectId);
            }
        }
    };
    IkeModelCollectionReader.prototype.loadLocation = function (target, schema, source) {
        var field = target.getField(schema.id);
        var isLocationData = function (x) { return x['provider'] == null; };
        if (isLocationData(source)) {
            // We are unsure if this is actually a GPS reading or a manual reading.
            // In theory manual readings will not have accuracy
            if (source.accuracy != null) {
                field.Mutator.gps(source, null);
                return;
            }
            field.Mutator.manual(source);
            return;
        }
        if (source.provider === 'edited') {
            field.Mutator.edited(source.value);
            return;
        }
        if (source.provider === 'gps') {
            field.Mutator.gps(source.value, source);
            return;
        }
        if (source.provider === 'manual') {
            field.Mutator.manual(source.value);
            return;
        }
        field.Mutator.capture(source.capture.objectId || source.capture.uuid);
    };
    IkeModelCollectionReader.prototype.loadNumber = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (typeof source === 'number') {
            field.Mutator.manual(source);
            return;
        }
        if (typeof source === 'string') {
            field.Mutator.manual(parseFloat(source));
            return;
        }
        if (source.provider === 'manual') {
            field.Mutator.manual(source.value);
            return;
        }
        if (source.provider === 'bearing' || source.provider === 'backbearing') {
            if (source.capture == null) {
                // Some bad data doesn't have a "capture". Revert to manual.
                field.Mutator.manual(source.value);
                return;
            }
            if (source.provider === number_field_1.CollectionModelFieldNumber.PROVIDER_BEARING) {
                field.Mutator.bearing(source.capture.objectId || source.capture.uuid);
                return;
            }
            if (source.provider === number_field_1.CollectionModelFieldNumber.PROVIDER_BACK_BEARING) {
                field.Mutator.backBearing(source.capture.objectId || source.capture.uuid);
                return;
            }
        }
        if (source.provider === 'sag') {
            var points = source.points.map(function (p) { return p.objectId || p.uuid; });
            field.Mutator.sag(source.start.objectId || source.start.uuid, source.end.objectId || source.end.uuid, points);
            return;
        }
        throw new Error("Unable to find field Serializer for ".concat(schema.type, " with provider ").concat(source['provider']));
    };
    IkeModelCollectionReader.prototype.loadVector = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (ReadUtil.isVectorPointToPointProvider(source)) {
            var cc = source.capture.points.map(function (ts) { return ts.capture.objectId; });
            field.Mutator.p2p(cc);
            return;
        }
        if (ReadUtil.isVectorCollectionProvider(source)) {
            field.Mutator.collection(source.collectionId);
            return;
        }
        if (ReadUtil.isVectorProviderManual(source)) {
            field.Mutator.manual(source.value);
            return;
        }
        return;
    };
    IkeModelCollectionReader.prototype.loadAnchor = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (ReadUtil.isAnchorLocationGPS(source)) {
            field.Mutator.gps(source.value);
            if (source.antennaHeight != null) {
                field.Mutator.setAntennaHeight(source.antennaHeight);
            }
            return;
        }
        if (ReadUtil.isAnchorP2P(source)) {
            var typedSource = source;
            var cc = typedSource.capture.points.map(function (ts) { return ts.capture.objectId; });
            field.Mutator.p2p(cc, typedSource.value.placement);
            return;
        }
        if (ReadUtil.isAnchorManual(source)) {
            field.Mutator.manualAnchor(source.value);
            return;
        }
        return;
    };
    IkeModelCollectionReader.prototype.loadHeight = function (target, schema, source) {
        var field = target.getField(schema.id);
        if (ReadUtil.isHeightProviderManual(source)) {
            field.Mutator.manual(source.value);
            return;
        }
        if (ReadUtil.isHeightSpanHeightProvider(source)) {
            var cc = source.capture.points.map(function (ts) { return ts.capture.objectId; });
            field.Mutator.spanHeight(cc);
            return;
        }
        if (ReadUtil.isHeightPhotomeasureProvider(source) || ReadUtil.isHeightPhotomeasureManualProvider(source)) {
            for (var _i = 0, _a = Object.keys(this.collection.drawableState); _i < _a.length; _i++) {
                var captureId = _a[_i];
                var drawableState = this.collection.getDrawableState(captureId);
                if (!drawableState.hasDrawable(source.drawable)) {
                    continue;
                }
                var drawable = drawableState.getDrawable(source.drawable);
                if (drawable == null) {
                    field.Mutator.manual(null); // TODO should we error here?
                    return;
                }
                drawable.label.Mutator.link(field);
                field.Mutator.drawable(drawable);
                return;
            }
            // Unable to find drawable
            field.Mutator.manual(source.value); // TODO should we error here?
            return;
        }
        throw new Error("Field ".concat(schema.id, ": Unable to parse Provider"));
    };
    IkeModelCollectionReader.prototype.loadVerticalSeparation = function (target, schema, source) {
        var field = target.getField(schema.id);
        for (var _i = 0, _a = Object.keys(this.collection.drawableState); _i < _a.length; _i++) {
            var captureId = _a[_i];
            var drawableState = this.collection.getDrawableState(captureId);
            // if one of the pairs is missing, continue
            if (!drawableState.hasDrawable(source.drawableTop) || !drawableState.hasDrawable(source.drawableBottom)) {
                continue;
            }
            var drawableTop = drawableState.getDrawable(source.drawableTop);
            if (drawableTop == null) {
                field.Mutator.manual(null); // TODO should we error here?
                return;
            }
            drawableTop.label.Mutator.link(field);
            field.Mutator.drawable(drawableTop);
            var drawableBottom = drawableState.getDrawable(source.drawableBottom);
            drawableBottom.label.Mutator.link(field);
            field.Mutator.drawable(drawableBottom);
            return;
        }
        // Unable to find drawable
        field.Mutator.manual(source.value); // TODO should we error here?
        return;
    };
    IkeModelCollectionReader.prototype.loadFileTool = function (target, schema, source) {
        var field = target.getField(schema.id);
        field.Mutator.manual({
            filename: source.filename,
            attachmentId: source.attachmentId,
            size: source.size,
            metadata: source.metadata
        });
    };
    IkeModelCollectionReader.prototype.readMeasurements = function () {
        var collectionJSON = this.json;
        if (collectionJSON.measurements == null) {
            return;
        }
        var measurements = Object.keys(collectionJSON.measurements);
        if (measurements.length === 0) {
            return;
        }
        for (var _i = 0, measurements_1 = measurements; _i < measurements_1.length; _i++) {
            var measurementId = measurements_1[_i];
            var measurement = collectionJSON.measurements[measurementId];
            if (measurement == null) {
                continue;
            }
            if (measurement.state.length === 0) {
                continue;
            }
            if (measurement.captureId == null) {
                throw new Error('Unable to read measurement, missing captureId ' + measurementId);
            }
            var drawableState = this.collection.getDrawableState(measurement.captureId);
            for (var _a = 0, _b = measurement.state; _a < _b.length; _a++) {
                var drawable = _b[_a];
                if (drawableState.drawables[drawable.id]) {
                    continue;
                }
                if (ReadUtil.isMarkerDrawable(drawable)) {
                    this.createMarkerDrawable(drawableState, drawable);
                }
                else if (ReadUtil.isLineDrawable(drawable)) {
                    this.createLineDrawable(drawableState, drawable);
                }
                else if (ReadUtil.isMaskDrawable(drawable)) {
                    this.createMaskDrawable(drawableState, drawable);
                }
                else {
                    throw new Error('Unable to read drawable, unknown type ' + drawable.tag);
                }
            }
        }
    };
    IkeModelCollectionReader.prototype.createMarkerDrawable = function (drawableState, obj) {
        var markerId = null;
        if (obj.type === core_api_1.MarkerType.BASE_OFFSET) {
            markerId = drawableState.Mutator.create('offset', 'offset');
            // We now hard code the offset + baseOffset Ids
            obj.id = 'offset';
            obj.label.id = 'offset:label';
        }
        else {
            markerId = drawableState.Mutator.create('marker', obj.id);
        }
        var marker = drawableState.getDrawable(markerId);
        marker.Mutator.setPosition(obj.x, obj.y);
        marker.Mutator.setInsight(obj.insight);
        var markerState = marker.state;
        markerState.type = obj.type;
        if (obj.position) {
            markerState.position = obj.position;
            markerState.pair = obj.pair;
        }
        var label = this.createLabelDrawable(drawableState, obj.label, obj.id, obj.insight);
        markerState.labelId = label.id;
        if (obj.type === core_api_1.MarkerType.BASE) {
            markerState.offset = obj['offset'];
        }
        return marker;
    };
    IkeModelCollectionReader.prototype.createLabelDrawable = function (drawableState, obj, parentId, insight) {
        var labelId = drawableState.Mutator.create('label', obj.id, parentId);
        var label = drawableState.getDrawable(labelId);
        var labelState = label.state;
        labelState.x = obj.x;
        labelState.y = obj.y;
        labelState.insight = insight;
        if (typeof obj.text === 'string') {
            labelState.text = [obj.text];
        }
        else if (Array.isArray(obj.text)) {
            labelState.text = obj.text;
        }
        return label;
    };
    IkeModelCollectionReader.prototype.createLineDrawable = function (drawableState, obj) {
        var lineId = drawableState.Mutator.create('line', obj.id);
        var line = drawableState.getDrawable(lineId);
        var lineState = line.state;
        var startPointId = drawableState.Mutator.create('line-point', obj.id + ':start', obj.id);
        var startPoint = drawableState.getDrawable(startPointId);
        lineState.startId = startPointId;
        startPoint.state.x = obj.start.x;
        startPoint.state.y = obj.start.y;
        startPoint.state.insight = obj.insight;
        var endPointId = drawableState.Mutator.create('line-point', obj.id + ':end', obj.id);
        var endPoint = drawableState.getDrawable(endPointId);
        lineState.endId = endPointId;
        endPoint.state.x = obj.end.x;
        endPoint.state.y = obj.end.y;
        endPoint.state.insight = obj.insight;
        var label = this.createLabelDrawable(drawableState, obj.label, obj.id, obj.insight);
        lineState.labelId = label.id;
        lineState.insight = obj.insight;
        return line;
    };
    IkeModelCollectionReader.prototype.createMaskDrawable = function (drawableState, obj) {
        var maskId = drawableState.Mutator.create('mask', obj.id);
        var mask = drawableState.getDrawable(maskId);
        if (mask.state == null) {
            throw new Error('Unable to create mask drawable, missing state');
        }
        mask.state.pukeko_data = obj.pukeko_data;
        return mask;
    };
    IkeModelCollectionReader.prototype.readBrightnessCorrections = function () {
        var collectionJSON = this.json;
        if (collectionJSON.brightnessCorrections == null) {
            return;
        }
        var brightnessCorrections = Object.keys(collectionJSON.brightnessCorrections);
        if (brightnessCorrections.length === 0) {
            return;
        }
        for (var _i = 0, brightnessCorrections_1 = brightnessCorrections; _i < brightnessCorrections_1.length; _i++) {
            var brightnessCorrectionId = brightnessCorrections_1[_i];
            var brightnessCorrection = collectionJSON.brightnessCorrections[brightnessCorrectionId];
            if (brightnessCorrection == null) {
                continue;
            }
            if (brightnessCorrection.state.length === 0) {
                continue;
            }
            if (brightnessCorrection.captureId == null) {
                throw new Error('Unable to read brightness correction, missing captureId ' + brightnessCorrectionId);
            }
            var brightnessCorrectionState = this.collection.getBrightnessCorrectionState(brightnessCorrection.captureId);
            for (var _a = 0, _b = brightnessCorrection.state; _a < _b.length; _a++) {
                var drawableBrightnessCorrection = _b[_a];
                if (brightnessCorrectionState.brightnessCorrections[drawableBrightnessCorrection.id]) {
                    continue;
                }
                if (ReadUtil.isGammaBrightnessCorrection(drawableBrightnessCorrection)) {
                    this.createGammaBrightnessCorrection(brightnessCorrectionState, drawableBrightnessCorrection);
                }
                else {
                    continue; // TODO should we error here?
                }
            }
        }
    };
    IkeModelCollectionReader.prototype.readImageVisibilities = function () {
        var collectionJSON = this.json;
        if (collectionJSON.imageVisibilities == null) {
            return;
        }
        var imageVisibilities = Object.keys(collectionJSON.imageVisibilities);
        if (imageVisibilities.length === 0) {
            return;
        }
        for (var _i = 0, imageVisibilities_1 = imageVisibilities; _i < imageVisibilities_1.length; _i++) {
            var imageVisibilityId = imageVisibilities_1[_i];
            var imageVisibility = collectionJSON.imageVisibilities[imageVisibilityId];
            if (imageVisibility == null || !imageVisibility.state) {
                continue;
            }
            if (imageVisibility.captureId == null) {
                throw new Error('Unable to read image visibility, missing captureId ' + imageVisibilityId);
            }
            var imageVisibilityState = this.collection.getImageVisibilityState(imageVisibility.captureId);
            if (imageVisibilityState.imageVisibility) {
                continue;
            }
            if (ReadUtil.isHiddenImageVisibility(imageVisibility.state)) {
                this.createHiddenImageVisibility(imageVisibilityState, imageVisibility.state);
            }
        }
    };
    IkeModelCollectionReader.prototype.createGammaBrightnessCorrection = function (brightnessCorrectionState, obj) {
        var gammaId = brightnessCorrectionState.Mutator.create('gamma', obj.id);
        var gamma = brightnessCorrectionState.getBrightnessCorrection(gammaId);
        var gammaState = gamma.state;
        gammaState.exponent = obj.exponent;
        return gamma;
    };
    IkeModelCollectionReader.prototype.createHiddenImageVisibility = function (hiddenImageVisibilityState, obj) {
        var hidden = hiddenImageVisibilityState.getImageVisibility();
        var hiddenState = hidden.state;
        hiddenState.hidden = obj.hidden;
        return hidden;
    };
    IkeModelCollectionReader.prototype.readCropParameters = function () {
        var collectionJSON = this.json;
        if (collectionJSON.cropParameters == null) {
            return;
        }
        var cropParameters = Object.keys(collectionJSON.cropParameters);
        if (cropParameters.length === 0) {
            return;
        }
        for (var _i = 0, cropParameters_1 = cropParameters; _i < cropParameters_1.length; _i++) {
            var cropParameterId = cropParameters_1[_i];
            var cropParameter = collectionJSON.cropParameters[cropParameterId];
            if (cropParameter == null) {
                continue;
            }
            if (cropParameter.state.length === 0) {
                continue;
            }
            if (cropParameter.captureId == null) {
                throw new Error('Unable to read crop parameter, missing captureId ' + cropParameterId);
            }
            var cropParameterState = this.collection.getCropParameterState(cropParameter.captureId);
            for (var _a = 0, _b = cropParameter.state; _a < _b.length; _a++) {
                var drawableCropParameter = _b[_a];
                if (cropParameterState.cropParameters[drawableCropParameter.id]) {
                    continue;
                }
                if (ReadUtil.isFreeCropParameter(drawableCropParameter)) {
                    this.createFreeCropParameter(cropParameterState, drawableCropParameter);
                }
                else {
                    continue; // TODO should we error here?
                }
            }
        }
    };
    IkeModelCollectionReader.prototype.createFreeCropParameter = function (cropParameterState, obj) {
        var freeId = cropParameterState.Mutator.create('free', obj.id);
        var free = cropParameterState.getCropParameter(freeId);
        var freeState = free.state;
        freeState.x = obj.x;
        freeState.y = obj.y;
        freeState.width = obj.width;
        freeState.height = obj.height;
        return free;
    };
    return IkeModelCollectionReader;
}());
exports.IkeModelCollectionReader = IkeModelCollectionReader;
//# sourceMappingURL=collection.model.read.js.map